import * as m from "@bokio/mobile-web-shared/core/model/model";
import { useApiConditionally } from "@bokio/mobile-web-shared/hooks/useApi/useApi";
import * as proxy from "@bokio/mobile-web-shared/services/api/proxy";

const FREE_PLANS: m.Entities.BokioPlan[] = [m.Entities.BokioPlan.Free];

interface CardExpiryWarning {
	isExpiringSoon: boolean;
	isExpired: boolean;
}

export const useCardExpiryWarning = (
	companyId: string,
	plan: m.Entities.BokioPlan,
	enabled = true,
): CardExpiryWarning => {
	const [billingSettings] = useApiConditionally(
		proxy.Bokio.Common.Web.Billing.BillingController.GetBillingSettings.Get,
		[companyId],
		() => enabled && !FREE_PLANS.includes(plan),
	);

	const customerInfo = billingSettings.data?.Data?.CustomerInfo;
	const warning = customerInfo?.DefaultCardWarning;
	return {
		isExpiringSoon: warning === m.Bokio.Common.Billing.Model.DefaultCardWarning.Expiring && !!customerInfo?.Card,
		isExpired: warning === m.Bokio.Common.Billing.Model.DefaultCardWarning.Expired && !!customerInfo?.Card,
	};
};
